module.exports = __webpack_public_path__ + "img/food_cake.65b3853b.png";